import GasPump from './GasPump';

export default GasPump;
